import AxiosJob from '@/services/api/job/axios_job'

export default {
  getHistoryByJob: (jobId, params) => {
    return AxiosJob.get(`job/${jobId}/history`, { params })
  },
}
